const a = `
  @font-face {
    font-display: swap;
    font-family: 'CarMaxSharpSansDisp-Bold';
    font-style: normal;
    font-weight: 700;
    src:
      url('https://www.carmax.com/shared/fonts/CarMaxSharpSansDisp-Bold.woff2') format('woff2'),
      url('https://www.carmax.com/shared/fonts/CarMaxSharpSansDisp-Bold.woff') format('woff'),
      url('https://www.carmax.com/shared/fonts/CarMaxSharpSansDisp-Bold.ttf') format('truetype');
  }
`, t = `
  @font-face {
    font-display: swap;
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    src:
      url('https://www.carmax.com/shared/fonts/lato-v16-latin-regular.woff2') format('woff2'),
      url('https://www.carmax.com/shared/fonts/lato-v16-latin-regular.woff') format('woff'),
      url('https://www.carmax.com/shared/fonts/lato-v16-latin-regular.ttf') format('truetype');
  }
`, o = `
  @font-face {
    font-display: swap;
    font-family: 'Lato';
    font-style: normal;
    font-weight: 700;
    src:
      url('https://www.carmax.com/shared/fonts/lato-v16-latin-700.woff2') format('woff2'),
      url('https://www.carmax.com/shared/fonts/lato-v16-latin-700.woff') format('woff'),
      url('https://www.carmax.com/shared/fonts/lato-v16-latin-700.ttf') format('truetype');
  }
`;
export {
  a as CarMaxSharpSansDispBold,
  t as Lato,
  o as LatoBold
};
